import Vue from 'vue';
import Vuex, {Store} from 'vuex';
import createLogger from 'vuex/dist/logger';

import facetedFilter from './modules/faceted-filter';
import cart from './modules/cart';
import gift from './modules/gift';
import order from './modules/order';

const debug = process.env.NODE_ENV !== 'production';

Vue.use(Vuex);

const store = new Store({
  strict: debug,
  plugins: debug ? [createLogger()] : [],
  modules: {
    cart,
    facetedFilter,
    gift,
    order
  },
  actions: {
    init({dispatch}) {
        dispatch('facetedFilter/init');
        dispatch('gift/init');
        dispatch('cart/init');
    }
  }
});

store.dispatch('init');

export default store;



// WEBPACK FOOTER //
// ./src/SiteBundle/Resources/assets/store/index.js